export default {
  // 共通
  common: {
    confirm: '確認',
    cancel: 'キャンセル',
    save: '保存',
    delete: '削除',
    edit: '編集',
    add: '追加',
    search: '検索',
    reset: 'リセット',
    export: 'エクスポート',
    import: 'インポート',
    upload: 'アップロード',
    download: 'ダウンロード',
    submit: '送信',
    back: '戻る',
    next: '次へ',
    previous: '前へ',
    close: '閉じる',
    refresh: '更新',
    loading: '読み込み中...',
    success: '操作成功',
    error: '操作失敗',
    warning: '警告',
    info: '情報'
  },
  
  // ログイン
  login: {
    title: 'ユーザーログイン',
    username: 'ユーザー名',
    password: 'パスワード',
    login: 'ログイン',
    logout: 'ログアウト',
    loginSuccess: 'ログイン成功',
    loginFailed: 'ログイン失敗',
    notLoggedIn: 'ログインしていません...',
    systemTitle: '清和環境技術・水素発生器管理システム',
    welcomeTitle: 'ようこそ - 水素発生器管理システム',
    usernameMinLength: 'ユーザー名は2文字以上である必要があります',
    passwordFormat: 'パスワード形式が正しくありません',
    verificationCode: '認証コードエラー（大文字小文字を区別）'
  },
  
  // 管理ページ
  admin: {
    title: '清和環境技術-管理システム',
    dashboard: 'ダッシュボード',
    menu: 'メニュー',
    logout: 'ログアウト'
  },
  
  // デバイス管理
  device: {
    title: 'デバイス管理',
    list: 'デバイス一覧',
    add: 'デバイス追加',
    edit: 'デバイス編集',
    delete: 'デバイス削除',
    status: 'デバイス状態',
    type: 'デバイスタイプ',
    online: 'オンライン',
    offline: 'オフライン',
    heartbeat: 'ハートビートデータ',
    record: '操作記録',
    activate: 'アクティベーション記録'
  },
  
  // 組織管理
  org: {
    title: '組織管理',
    list: '組織一覧',
    add: '組織追加',
    edit: '組織編集',
    delete: '組織削除',
    name: '組織名',
    code: '組織コード',
    type: '組織タイプ'
  },
  
  // 水カード管理
  card: {
    title: '水カード管理',
    list: '水カード一覧',
    add: '水カード追加',
    bind: '水カードバインド',
    unbind: '水カードアンバインド',
    import: '水カードインポート',
    export: '水カードエクスポート',
    serialNo: 'シリアル番号',
    cardNo: 'カード番号',
    status: '状態'
  },
  
  // システム設定
  setting: {
    title: 'システム設定',
    general: '一般設定',
    security: 'セキュリティ設定',
    notification: '通知設定'
  },
  
  // データ統計
  stats: {
    title: 'データ統計',
    tds: 'TDS統計',
    volume: '水量統計',
    usage: '使用統計'
  },
  
  // フッター
  footer: {
    copyright: '© 2023 - 清和環境科技有限公司 全著作権所有',
    icp: 'ICP記録：',
    techSupport: '© 技術サポート：広州冠君水素技術有限公司'
  },
  
  // エラーメッセージ
  error: {
    network: 'ネットワークエラー',
    server: 'サーバーエラー',
    permission: '権限不足',
    param: 'パラメータエラー',
    notFound: 'データが存在しません',
    pageNotFound: '申し訳ございませんが、アクセスしたページは存在しません'
  },
  
  // メニュー関連
  menu: {
    // デバイス管理
    equipment: 'デバイス・フィルターライブラリ',
    filterRecord: 'フィルター交換記録',
    version: 'ホームバージョンライブラリ',
    dataQuery: 'TCPデータクエリ',
    heartbeat: 'ハートビートデータ',
    singleUse: '単回使用データ',
    bindStats: 'バインディング統計',
    
    // 顧客管理
    customer: '顧客管理',
    agentCheck: 'エージェント審査',
    agentProfit: 'エージェント利益管理',
    promotionRoute: 'プロモーションルート設定',
    partyType: 'パーティータイプ管理',
    
    // MQTTデータクエリ
    mqttQuery: 'MQTTデータクエリ',
    statusQuery: 'ステータスクエリ',
    outputRecord: '出力記録クエリ',
    debug: 'デバイスデバッグページ',
    waterTotal: '総出水クエリ',
    
    // システム管理
    adminAccount: '管理者アカウント',
    deviceType: 'デバイスタイプ管理',
    defaultSettings: 'デフォルトシステム設定',
    flowConfig: '水流パーソナライゼーション',
    waterConfig: '温度水量設定',
    businessLog: 'ビジネスログ',
    
    // 支払い管理
    payment: '支払い管理',
    order: '注文管理',
    statistics: 'データ統計',
    waterPrice: '水量価格設定',
    recharge: 'チャージ'
  }
}
